export const blockLeftCSS = {
	backgroundColor: '#F8F8F8',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	height: '100%',
	borderTopLeftRadius: 10,
	borderTopRightRadius: { xs: 10, lg: 'inherit' },
	borderBottomLeftRadius: 10,
}